// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Vey3","loaderOuter":"PageOverlayLoader_loaderOuter__e16qX"};